import React from 'react';
import "./Home.css";
import Product from "./Product";
function Home() {
    return (
        <div className="home">
            <div className="home_container">
                
                <img className="home_image"  
                src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
                 alt=""/>
                 <div className="home_row">
                 <Product  title="The lean startup: How to constant Innovation Creates Radically Successiful in The Life"
                     price={29.99}
                     image="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL.__AC_SY400_.jpg" 
                     rating={5} />
                     <Product 
                     title="HUAWEI Y9s (Breathing Crystal, 6GB RAM, 128GB Storage, Ultra FullView Display, 48MP AI Triple Camera, Side-Mounted Fingerprint, 4000mAH Powerfull Battery, Kirin 710F, Android Based EMUI 9.1)"
                     price={35.99}
                     image="https://images-na.ssl-images-amazon.com/images/I/61yERfK2vHL._SL1024_.jpg" 
                     rating={4} />
                      
                     
                 </div>
                 <div className="home_row">
                 <Product  title="Klikfit KFM Metal Exercise Cycle: Its help in the health of our interstal in make body in shape"
                     price={39.99}
                     image="https://images-na.ssl-images-amazon.com/images/I/718YQqD-7hL._SL1500_.jpg" 
                     rating={3} />
                      <Product  title="Ambrane 10000mAh Li-Polymer Powerbank with Compact Size & Fast Charging for Smartphones, Smart Watches, Neckbands & Other Devices (Capsule 10K, Black)"
                     price={13.99}
                     image="https://images-na.ssl-images-amazon.com/images/I/714kahV60VL._SL1500_.jpg" 
                     rating={4} />
                      <Product  title="Redmi Earbuds 2C in-Ear Truly Wireless Earphones [Black]"
                     price={9.99}
                     image="https://images-na.ssl-images-amazon.com/images/I/61k1jK9XwVL._SL1500_.jpg" 
                     rating={5} />
                     {/* Product*3 */}
                 </div>
                 <div className="home_row">
                 <Product  title="eAirtec 81 cm (32 inches) HD Ready LED TV 32DJ (Black) (2020 Model):These Provide a Amazing Exprence in Seen Movies and Web searise"
                     price={49.99}
                     image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg" 
                     rating={4} />
                 </div>
                 </div>
            
        </div>
    )
}

export default Home;
